export default {
	"login": {
		"id": 6,
		"name": "登录部分",
		"isDrop": 0,
		"children": {
			"forget": {
				"id": 48,
				"name": "忘记密码？",
				"remarks": "登录按钮上方忘记密码文字"
			},
			"contacts": {
				"id": 35,
				"name": "变更联系人",
				"remarks": "登录按钮上方变更联系人文字"
			},
			"loginTitle": {
				"id": 7,
				"name": "欢迎登录",
				"remarks": "登录界面输入框上方标题"
			},
			"loginFlowChart": {
				"id": 34,
				"name": "高校填报流程图",
				"remarks": "登录右下角高校填报流程按钮名称"
			},
			"loginPasswordPlaceholder": {
				"id": 9,
				"name": "2025年填报首次登陆请使用旧密码",
				"remarks": "登录界面密码输入框内的提示信息"
			},
			"loginUsernamePlaceholder": {
				"id": 8,
				"name": "2025年填报首次登陆请使用旧用户名",
				"remarks": "登录界面用户名输入框内的提示信息"
			},
			"technicalSupportText": {
				"id": 106,
				"name": "进入系统支持群",
				"remarks": "系统支持群按钮文字"
			},
			"technicalSupportImg": {
				"id": 107,
				"name": "http://122.51.76.10:8801/files/uploads/20250217/2025021714063151680.png",
				"type": "img",
				"wrap": true,
				"remarks": "系统支持群二维码",
				"fieldName": "technicalSupport"
			},
			"loginFlowChartImg": {
				"id": 108,
				"name": "",
				"type": "img",
				"wrap": true,
				"remarks": "高校填报流程图上传",
				"fieldName": "flowChart"
			}
		}
	},
	"floorText": {
		"id": 2,
		"name": "网站页脚部分",
		"isDrop": 0,
		"children": {
			"first": {
				"id": 3,
				"name": "咨询时间：星期一至星期五 9:00-11:00; 14:00-17:00",
				"remarks": "网页页脚第一部分文字内容"
			},
			"third": {
				"id": 5,
				"name": "",
				"remarks": "网页页脚第三部分文字内容"
			},
			"second": {
				"id": 4,
				"name": "技术咨询QQ群：867330158。管理平台联系电话：18600728838，18600198838",
				"remarks": "网页页脚第二部分文字内容"
			}
		}
	},
	"systemIco": {
		"id": 2.1,
		"name": "http://122.51.76.10:8801/files/uploads/20250216/2025021620335383048.png",
		"type": "img",
		"wrap": true,
		"remarks": "网站logo",
		"fieldName": "systemIco"
	},
	"dataSummary": {
		"id": 97,
		"name": "数据一键汇总部分",
		"isDrop": 1,
		"children": {
			"reportDioTips": {
				"id": 101,
				"name": "还有所属高校未提交数据或者高校数据未完成审核，请点击“所属高校数据汇总”进行数据核查，您暂时不能不能进行部门年度报告填报操作。",
				"wrap": true,
				"remarks": "点击填报时未通过的弹窗提示"
			},
			"isReportStatus": {
				"id": 102,
				"name": "1",
				"remarks": "是否允许进入填报弹窗页面，1是0否"
			},
			"tableErrorTips": {
				"id": 100,
				"name": "数据汇总检查未通过，所属高校还有以下单位未进行填报或者审核，请完成全部所属单位审核后进行数据汇总。",
				"wrap": true,
				"remarks": "数据汇总检查未通过提示"
			},
			"searchButtonText": {
				"id": 98,
				"name": "数据一键汇总",
				"remarks": "头部数据一键汇总按钮文字"
			},
			"tableSuccessTips": {
				"id": 99,
				"name": "数据汇总检查通过，所属高校数据已经完成汇总，请点击“部门年报填写”菜单查看详情，并进行年报填报提交。",
				"wrap": true,
				"remarks": "数据汇总检查通过提示"
			}
		}
	},
	"systemTitle": {
		"id": 1,
		"name": "高校教学实验室安全工作年度报告管理系统",
		"remarks": "网站标题"
	},
	"reportBanner": {
		"id": 2.2,
		"name": "http://122.51.76.10:8801/files/uploads/20250216/2025021620340155731.png",
		"type": "img",
		"wrap": true,
		"remarks": "填报入口首页banner",
		"fieldName": "reportBanner"
	},
	"sysContactUs": {
		"id": 87,
		"name": "系统帮助部分的联系我们",
		"isDrop": 1,
		"children": {
			"first": {
				"id": 88,
				"name": "政策咨询联系电话：010-66096925。",
				"remarks": "第1排的内容"
			},
			"third": {
				"id": 89.1,
				"name": "管理平台联系电话：18600728838（章老师）；18600198838（尤老师）。",
				"remarks": "第3排的内容"
			},
			"second": {
				"id": 89,
				"name": "技术咨询QQ群：867330158。",
				"remarks": "第2排的内容"
			}
		}
	},
	"reportDioHight": {
		"id": 50,
		"name": "网站内高校数据填报弹窗部分",
		"isDrop": 1,
		"children": {
			"dioTop": {
				"id": 53,
				"name": "20px",
				"remarks": "弹窗距离页面顶部的距离（必须添加单位，px或者百分比%单位）"
			},
			"dioTitle": {
				"id": 51,
				"name": "高校实验室安全工作年度报告提交",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 52,
				"name": "90%",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"secondM1": {
				"id": 90,
				"name": "http://www.moe.gov.cn/srcsite/A16/s7062/202504/t20250419_1126415.html",
				"wrap": true,
				"remarks": "高等学校实验室安全分级分类管理办法_(试行)跳转链接"
			},
			"switchText": {
				"id": 54,
				"name": "封面信息,1.基本状况,2.体系机制建设,3.宣传教育,4.专项检查,5.应急能力,6.数字化建设,7.典例举措,8.存在问题,9.审核意见",
				"wrap": true,
				"remarks": "分步标题，以英文逗号隔开，如：封面信息,1.基本状况,2.体系机制建设"
			},
			"uploadText": {
				"id": 77,
				"name": "上传完整盖章版报告（PDF）",
				"remarks": "上传完整盖章版报告（PDF）按钮文字"
			},
			"downloadText": {
				"id": 76,
				"name": "下载完整报告",
				"remarks": "下载完整报告按钮文字"
			},
			"isDownloadModel": {
				"id": 103,
				"name": 1,
				"remarks": "是否显示模版下载（1是0否）"
			},
			"downloadModelUrl": {
				"id": 95,
				"name": "http://122.51.76.10:8090/files/%EF%BC%88%E9%AB%98%E7%AD%89%E5%AD%A6%E6%A0%A1%EF%BC%892025%E5%B9%B4%E9%AB%98%E6%A0%A1%E6%95%99%E5%AD%A6%E5%AE%9E%E9%AA%8C%E5%AE%A4%E5%AE%89%E5%85%A8%E5%B7%A5%E4%BD%9C%E5%B9%B4%E5%BA%A6%E6%8A%A5%E5%91%8A.pdf",
				"wrap": true,
				"remarks": "模版下载链接"
			}
		}
	},
	"loginResetPassword": {
		"id": 36,
		"name": "登录部分首次登录强制重置密码弹窗",
		"isDrop": 0,
		"children": {
			"code": {
				"id": 46,
				"name": "短信验证码：",
				"remarks": "表单部分短信验证码"
			},
			"tips1": {
				"id": 44,
				"name": "如联系人已变更或原电话号码停止使用，请通过首页",
				"remarks": "提示信息第1部分"
			},
			"tips2": {
				"id": 45,
				"name": "功能提交变更申请",
				"remarks": "提示信息第2部分"
			},
			"mobile": {
				"id": 43,
				"name": "联系人电话：",
				"remarks": "表单部分联系人电话"
			},
			"confirm": {
				"id": 49,
				"name": "确认密码：",
				"remarks": "表单部分确认密码"
			},
			"liaison": {
				"id": 42,
				"name": "系统联系人：",
				"remarks": "表单部分系统联系人"
			},
			"dioTitle": {
				"id": 37,
				"name": "重要提示:系统已全面升级，为保障信息安全，请重置登录密码",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 38,
				"name": "800px",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"nickname": {
				"id": 41,
				"name": "学校或部门名称：",
				"remarks": "表单部分学校名称"
			},
			"password": {
				"id": 47,
				"name": "新密码：",
				"remarks": "表单部分新密码"
			},
			"labelAlign": {
				"id": 40,
				"name": 1,
				"remarks": "表单标题对齐方式(1为左对齐2为右对齐3为输入框顶部)"
			},
			"labelWidth": {
				"id": 39,
				"name": "140",
				"remarks": "表单标题宽度"
			},
			"codePlaceholder": {
				"id": 46.1,
				"name": "请输入短信验证码",
				"remarks": "短信验证码输入框内提示"
			},
			"mobilePlaceholder": {
				"id": 43.1,
				"name": "选择学校或部门后自动获取",
				"remarks": "联系人电话输入框内提示"
			},
			"confirmPlaceholder": {
				"id": 49.1,
				"name": "请输入新密码(密码长度8-20个字符，必须包含大小写字母、数字、特殊字符)",
				"remarks": "确认密码输入框内提示"
			},
			"liaisonPlaceholder": {
				"id": 42.1,
				"name": "选择学校或部门后自动获取",
				"remarks": "系统联系人输入框内提示"
			},
			"nicknamePlaceholder": {
				"id": 41.1,
				"name": "请输入学校或部门名称",
				"remarks": "学校名称输入框内提示"
			},
			"passwordPlaceholder": {
				"id": 47.1,
				"name": "请输入新密码(密码长度8-20个字符，必须包含大小写字母、数字、特殊字符)",
				"remarks": "新密码输入框内提示"
			}
		}
	},
	"loginChangeContacts": {
		"id": 10,
		"name": "登录部分变更联系人弹窗",
		"isDrop": 0,
		"children": {
			"files": {
				"id": 20,
				"name": "上传变更申请：",
				"remarks": "表单部分上传变更申请"
			},
			"mobile": {
				"id": 19,
				"name": "新联系人电话：",
				"remarks": "表单部分联系人电话"
			},
			"liaison": {
				"id": 18,
				"name": "新联系人姓名：",
				"remarks": "表单部分新联系人姓名"
			},
			"dioTitle": {
				"id": 11,
				"name": "变更联系人",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 12,
				"name": "800px",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"username": {
				"id": 16,
				"name": "登录账号：",
				"remarks": "表单部分登录账号"
			},
			"labelAlign": {
				"id": 14,
				"name": 1,
				"remarks": "表单标题对齐方式(1为左对齐2为右对齐3为输入框顶部)"
			},
			"labelWidth": {
				"id": 13,
				"name": "160",
				"remarks": "表单标题宽度"
			},
			"schoolName": {
				"id": 15,
				"name": "学校或部门名称：",
				"remarks": "表单部分学校名称"
			},
			"old_liaison": {
				"id": 17,
				"name": "原联系人姓名：",
				"remarks": "表单部分原联系人姓名"
			},
			"email": {
				"id": 21,
				"name": "邮箱：",
				"remarks": "表单部分邮箱"
			},
			"filesModelUrl": {
				"id": 96,
				"name": "http://122.51.76.10:8090/files/%E9%AB%98%E6%A0%A1%E6%95%99%E5%AD%A6%E5%AE%9E%E9%AA%8C%E5%AE%A4%E5%AE%89%E5%85%A8%E5%B7%A5%E4%BD%9C%E5%B9%B4%E5%BA%A6%E6%8A%A5%E5%91%8A%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E5%8F%98%E6%9B%B4%E4%BA%8B%E9%A1%B9%E8%AF%B4%E6%98%8E.pdf",
				"wrap": true,
				"remarks": "表单部分《变更申请模版下载》下载链接"
			},
			"emailPlaceholder": {
				"id": 18.2,
				"name": "请输入邮箱",
				"remarks": "邮箱输入框内提示"
			},
			"filesModelName": {
				"id": 21,
				"name": "变更申请模版下载",
				"remarks": "表单部分《变更申请模版下载》文字"
			},
			"mobilePlaceholder": {
				"id": 19.1,
				"name": "请输入新联系人电话",
				"remarks": "新联系人电话输入框内提示"
			},
			"liaisonPlaceholder": {
				"id": 18.1,
				"name": "请输入新联系人姓名",
				"remarks": "新联系人姓名输入框内提示"
			},
			"usernamePlaceholder": {
				"id": 16.1,
				"name": "选择学校或部门后自动获取",
				"remarks": "登录账号输入框内提示"
			},
			"schoolNamePlaceholder": {
				"id": 15.1,
				"name": "请输入学校或部门名称",
				"remarks": "学校名称输入框内提示"
			},
			"old_liaisonPlaceholder": {
				"id": 17.1,
				"name": "选择学校或部门后自动获取",
				"remarks": "原联系人姓名输入框内提示"
			}
		}
	},
	"loginForgotPassword": {
		"id": 22,
		"name": "登录部分忘记密码弹窗",
		"isDrop": 0,
		"children": {
			"code": {
				"id": 31,
				"name": "邮箱验证码：",
				"remarks": "表单部分邮箱验证码"
			},
			"email": {
				"id": 30,
				"name": "邮箱：",
				"remarks": "表单部分邮箱"
			},
			"confirm": {
				"id": 33,
				"name": "确认密码：",
				"remarks": "表单部分确认密码"
			},
			"dioTitle": {
				"id": 23,
				"name": "找回密码",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 24,
				"name": "800px",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"nickname": {
				"id": 27,
				"name": "学校或部门名称：",
				"remarks": "表单部分学校名称"
			},
			"password": {
				"id": 32,
				"name": "新密码：",
				"remarks": "表单部分新密码"
			},
			"username": {
				"id": 28,
				"name": "登录账号：",
				"remarks": "表单部分用户名称"
			},
			"labelAlign": {
				"id": 26,
				"name": 1,
				"remarks": "表单标题对齐方式(1为左对齐2为右对齐3为输入框顶部)"
			},
			"labelWidth": {
				"id": 25,
				"name": "160",
				"remarks": "表单标题宽度"
			},
			"codePlaceholder": {
				"id": 31.1,
				"name": "请输入邮箱验证码",
				"remarks": "邮箱验证码输入框内提示"
			},
			"emailPlaceholder": {
				"id": 30.1,
				"name": "选择学校或部门后自动获取",
				"remarks": "手机号码输入框内提示"
			},
			"confirmPlaceholder": {
				"id": 33.1,
				"name": "请输入新密码(密码长度8-20个字符，必须包含大小写字母、数字、特殊字符)",
				"remarks": "确认密码输入框内提示"
			},
			"nicknamePlaceholder": {
				"id": 27.1,
				"name": "请输入学校或部门名称",
				"remarks": "学校名称输入框内提示"
			},
			"passwordPlaceholder": {
				"id": 32.1,
				"name": "请输入新密码(密码长度8-20个字符，必须包含大小写字母、数字、特殊字符)",
				"remarks": "新密码输入框内提示"
			},
			"usernamePlaceholder": {
				"id": 29,
				"name": "选择学校或部门后自动获取",
				"remarks": "表单部分用户名称输入框提示内容"
			}
		}
	},
	"reportDioRegardingBureau": {
		"id": 80,
		"name": "网站内有关部门（单位）教育司（局）数据填报弹窗部分",
		"isDrop": 1,
		"children": {
			"dioTop": {
				"id": 83,
				"name": "20px",
				"remarks": "弹窗距离页面顶部的距离（必须添加单位，px或者百分比%单位）"
			},
			"dioTitle": {
				"id": 81,
				"name": "有关部门（单位）教育司（局）实验室安全工作年度报告提交",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 82,
				"name": "90%",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"secondM1": {
				"id": 92,
				"name": "http://www.moe.gov.cn/srcsite/A16/s7062/202504/t20250419_1126415.html",
				"wrap": true,
				"remarks": "高等学校实验室安全分级分类管理办法_(试行)跳转链接"
			},
			"switchText": {
				"id": 84,
				"name": "封面信息,1.基本状况,2.体系机制建设,3.宣传教育,4.专项检查,5.应急能力,6.数字化建设,7.典例举措,8.工作概况,9.其他情况,10.审核意见",
				"wrap": true,
				"remarks": "分步标题，以逗号隔开，如：封面信息,1.基本状况,2.体系机制建设"
			},
			"uploadText": {
				"id": 86,
				"name": "上传完整盖章版报告（PDF）",
				"remarks": "上传完整盖章版报告（PDF）按钮文字"
			},
			"downloadText": {
				"id": 85,
				"name": "下载完整报告",
				"remarks": "下载完整报告按钮文字"
			},
			"isDownloadModel": {
				"id": 104,
				"name": "0",
				"remarks": "是否显示模版下载（1是0否）"
			},
			"downloadModelUrl": {
				"id": 94,
				"name": "",
				"wrap": true,
				"remarks": "模版下载链接"
			}
		}
	},
	"reportDioMinistryEducation": {
		"id": 71,
		"name": "网站内省级教育行政部门数据填报弹窗部分",
		"isDrop": 1,
		"children": {
			"dioTop": {
				"id": 74,
				"name": "20px",
				"remarks": "弹窗距离页面顶部的距离（必须添加单位，px或者百分比%单位）"
			},
			"dioTitle": {
				"id": 72,
				"name": "省级教育行政部门实验室安全工作年度报告提交",
				"remarks": "弹窗标题"
			},
			"dioWidth": {
				"id": 73,
				"name": "90%",
				"remarks": "弹窗宽度（必须添加单位，px或者百分比%单位）"
			},
			"secondM1": {
				"id": 91,
				"name": "http://www.moe.gov.cn/srcsite/A16/s7062/202504/t20250419_1126415.html",
				"wrap": true,
				"remarks": "高等学校实验室安全分级分类管理办法_(试行)跳转链接"
			},
			"switchText": {
				"id": 75,
				"name": "封面信息,1.基本状况,2.体系机制建设,3.宣传教育,4.专项检查,5.应急能力,6.数字化建设,7.典例举措,8.工作概况,9.其他情况,10.审核意见",
				"wrap": true,
				"remarks": "分步标题，以逗号隔开，如：封面信息,1.基本状况,2.体系机制建设"
			},
			"uploadText": {
				"id": 79,
				"name": "上传完整盖章版报告（PDF）",
				"remarks": "上传完整盖章版报告（PDF）按钮文字"
			},
			"downloadText": {
				"id": 78,
				"name": "下载完整报告",
				"remarks": "下载完整报告按钮文字"
			},
			"isDownloadModel": {
				"id": 105,
				"name": "0",
				"remarks": "是否显示模版下载（1是0否）"
			},
			"downloadModelUrl": {
				"id": 93,
				"name": "",
				"wrap": true,
				"remarks": "模版下载链接"
			}
		}
	}
}